import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4 p-0">
      {/* Footer Top */}
      <div className="footer-top aos p-0" data-aos="fade-up">
        <div className="container px-0">
          <div className="row px-0 ">
            {/* Footer Contact */}
       <div className="col-lg-3 px-0">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logoo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a diverse fleet of vehicles to suit every need, including compact cars, sedans, SUVs, and luxury vehicles.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+918722158435" style={{ color: "#fff", textDecoration: "none" }}>+91 8722158435</a>
      </p>
   

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CE8304" }}></i>Belgaum Taxi Service</h6>
      P No 30 cCTS No 7023,
Sector No 9 Malmaruti Anjaneya Nagar, 
Belgaum, Karnataka - 590017.


      </p>
    </div>




<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11693.657999186493!2d74.510496181882!3d15.860879060016769!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf615f0a390e6f%3A0xc95cb1104f323ae4!2sBelgaum%20Car%20Rental%20Service!5e1!3m2!1sen!2sin!4v1785463093207!5m2!1sen!2sin" width="100%" height="250"  allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>


    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/belgaumtaxiservices/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61592579373582" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/belgaum_taxi" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/belgaumtaxiservices/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
              <a
  href="https://www.youtube.com/@BelgaumTaxiServices"
  target="_blank"
  rel="noreferrer"
>
  <i className="fab fa-youtube text-white"></i>
</a>
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Cab-Service-in-Belgaum"><i className="fa fa-car darkcolor"></i> Cab Service in Belgaum</Link></li>

<li><Link to="/Belgaum-Taxi-Service"><i className="fa fa-car darkcolor"></i> Belgaum Taxi Service</Link></li>

<li><Link to="/Belgaum-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Goa Cab</Link></li>

<li><Link to="/Belgaum-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Mahabaleshwar Cab</Link></li>

<li><Link to="/Belgaum-to-Kerala-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Kerala Cab Service</Link></li>

<li><Link to="/Goa-to-Belgaum-Cab"><i className="fa fa-car darkcolor"></i> Goa to Belgaum Cab</Link></li>

<li><Link to="/Belgaum-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Mumbai Cab</Link></li>

<li><Link to="/Belgaum-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Bangalore Cab</Link></li>

<li><Link to="/Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Goa Cab Service</Link></li>

<li><Link to="/Taxi-Service-in-Goa"><i className="fa fa-car darkcolor"></i> Taxi Service in Goa</Link></li>

<li><Link to="/Cheapest-Cab-Service-in-Goa"><i className="fa fa-car darkcolor"></i> Cheapest Cab Service in Goa</Link></li>

<li><Link to="/Corporate-Cab-Services-in-Belgaum"><i className="fa fa-car darkcolor"></i> Corporate Cab Services in Belgaum</Link></li>

<li><Link to="/Innova-Crysta-Rent-in-Belgaum"><i className="fa fa-car darkcolor"></i> Innova Crysta Rent in Belgaum</Link></li>

<li><Link to="/Ertiga-on-Rent-in-Belgaum"><i className="fa fa-car darkcolor"></i> Ertiga on Rent in Belgaum</Link></li>

<li><Link to="/Tempo-Traveller-Rent-in-Belgaum"><i className="fa fa-car darkcolor"></i> Tempo Traveller Rent in Belgaum</Link></li>

<li><Link to="/Mini-Bus-Rental-Belgaum"><i className="fa fa-car darkcolor"></i> Mini Bus Rental Belgaum</Link></li>

<li><Link to="/Swift-Dzire-on-Rent-in-Belgaum"><i className="fa fa-car darkcolor"></i> Swift Dzire on Rent in Belgaum</Link></li>

<li><Link to="/Urbania-on-Rent-in-Belgaum"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Belgaum</Link></li>

<li><Link to="/Wedding-Car-Rental-in-Belgaum"><i className="fa fa-car darkcolor"></i> Wedding Car Rental in Belgaum</Link></li>

<li><Link to="/Cabs-in-Belgaum"><i className="fa fa-car darkcolor"></i> Cabs in Belgaum</Link></li>

<li><Link to="/Belgaum-to-Hubli-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Hubli Cab</Link></li>
                   
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>

<li><Link to="/Belgaum-to-Dharwad-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Dharwad Cab</Link></li>

<li><Link to="/Belgaum-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Kolhapur Cab</Link></li>

<li><Link to="/Belgaum-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum Airport Cab Service</Link></li>

<li><Link to="/Belgaum-to-Bagalkot-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Bagalkot Cab</Link></li>

<li><Link to="/Belgaum-to-Bijapur-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Bijapur Cab</Link></li>

<li><Link to="/Pune-to-Belgaum-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Pune to Belgaum Taxi Fare</Link></li>

<li><Link to="/Belgaum-to-Shivamogga-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Shivamogga Cab</Link></li>

<li><Link to="/Belgaum-to-Hyderabad-Cabs"><i className="fa fa-car darkcolor"></i> Belgaum to Hyderabad Cabs</Link></li>

<li><Link to="/Belgaum-to-Shirdi-Cabs"><i className="fa fa-car darkcolor"></i> Belgaum to Shirdi Cabs</Link></li>

<li><Link to="/Belgaum-to-Mangalore-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Mangalore Cab</Link></li>

<li><Link to="/Belgaum-to-Murudeshwar-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Murudeshwar Cab</Link></li>

<li><Link to="/Belgaum-to-Koppal-Taxi-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Koppal Taxi Service</Link></li>

<li><Link to="/Belgaum-to-Nipani-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Nipani Cab</Link></li>

<li><Link to="/Belgaum-to-Chikodi-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Chikodi Taxi</Link></li>

<li><Link to="/Belgaum-to-Londa-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Londa Cab</Link></li>

<li><Link to="/Belgaum-to-Mudhol-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Mudhol Taxi</Link></li>

<li><Link to="/Belgaum-to-Jamkhandi-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Jamkhandi Cab</Link></li>

<li><Link to="/Belgaum-to-Haveri-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Haveri Cab</Link></li>

<li><Link to="/Belgaum-to-Ranebennur-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Ranebennur Cab</Link></li>

<li><Link to="/Belgaum-to-Davangere-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Davangere Taxi</Link></li>

              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>



<li><Link to="/Belgaum-to-Chitradurga-Taxi-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Chitradurga Taxi Service</Link></li>

<li><Link to="/Belgaum-to-Mysore-Tour-Package"><i className="fa fa-car darkcolor"></i> Belgaum to Mysore Tour Package</Link></li>

<li><Link to="/Belgaum-to-Mysore-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Mysore Cab Service</Link></li>

<li><Link to="/Belgaum-to-Ganpatipule-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Ganpatipule Cab</Link></li>

<li><Link to="/Belgaum-to-Satara-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Satara Cab Service</Link></li>

<li><Link to="/Belgaum-to-Miraj-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Miraj Cab</Link></li>

<li><Link to="/Belgaum-to-Sangli-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Sangli Taxi</Link></li>

<li><Link to="/Belgaum-to-Athani-Cab-Booking"><i className="fa fa-car darkcolor"></i> Belgaum to Athani Cab Booking</Link></li>

<li><Link to="/Belgaum-to-Pandharpur-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Pandharpur Cab</Link></li>

<li><Link to="/Belgaum-to-Tuljapur-Tour-Package"><i className="fa fa-car darkcolor"></i> Belgaum to Tuljapur Tour Package</Link></li>

<li><Link to="/Belgaum-Dharmasthala-Cabs"><i className="fa fa-car darkcolor"></i> Belgaum Dharmasthala Cabs</Link></li>

<li><Link to="/Belgaum-to-Solapur-Taxi-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Solapur Taxi Service</Link></li>

<li><Link to="/Belgaum-to-Gadag-Cabs"><i className="fa fa-car darkcolor"></i> Belgaum to Gadag Cabs</Link></li>

<li><Link to="/Belgaum-to-Hospet-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Belgaum to Hospet Taxi Fare</Link></li>

<li><Link to="/Belgaum-to-Kittur-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Kittur Taxi</Link></li>

<li><Link to="/Belgaum-to-Gokarna-Tour-Packages"><i className="fa fa-car darkcolor"></i> Belgaum to Gokarna Tour Packages</Link></li>

<li><Link to="/Belgaum-to-Kumta-Cab"><i className="fa fa-car darkcolor"></i> Belgaum to Kumta Cab</Link></li>

<li><Link to="/Belgaum-to-Honnavar-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Honnavar Cab Service</Link></li>

<li><Link to="/Belgaum-to-Sirsi-Cabs-Taxi"><i className="fa fa-car darkcolor"></i> Belgaum to Sirsi Cabs Taxi</Link></li>

<li><Link to="/Belgaum-to-Pan-India-Cab-Service"><i className="fa fa-car darkcolor"></i> Belgaum to Pan India Cab Service</Link></li>
 </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Belgaum Taxi Service</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


